import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from "axios";

import { LOCAL_STORAGE_KEY } from "../constants";
import Routers from "../constants/routers";
import { getToken, trimData } from "../utils/common/common";

// Helper function to create axios instance with interceptors
const createAxiosInstance = (baseURL: string): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    // timeout: 60000,
    headers: {
      "Content-Type": "application/json"
      // "ngrok-skip-browser-warning": "true"
    }
  });

  // Add request interceptor
  instance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // Trim data for POST, PUT, PATCH requests
      const method = config.method?.toUpperCase();
      if (method && ["POST", "PUT", "PATCH"].includes(method) && config.data) {
        // Don't trim FormData
        if (!(config.data instanceof FormData)) {
          config.data = trimData(config.data);
        }
      }

      return config;
    },
    (err: AxiosError) => Promise.reject(err)
  );

  // Add response interceptor
  instance.interceptors.response.use(
    (res) => {
      return Promise.resolve(res);
    },
    (error) => {
      const status = error?.response?.status;
      const currentPath = window?.location?.pathname || "";
      const origin = window?.location?.origin || "";

      const redirect = (path: string) => {
        window.location.href = origin + path;
      };

      const statusRouteMap: Record<number, string> = {
        // 400: Routers.BadRequest,
        401: Routers.Login,
        403: Routers.Forbidden,
        404: Routers.NotFound
      };

      if (status && statusRouteMap[status] && !currentPath.includes(statusRouteMap[status])) {
        if (status === 401) {
          localStorage.removeItem(LOCAL_STORAGE_KEY.ACCESS_TOKEN);
        }
        redirect(statusRouteMap[status]);
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

// Create instances with different base URLs
const axiosInstance = createAxiosInstance((process.env.REACT_APP_API_URL || "") + "/affiliate");
const axiosInstanceCommon = createAxiosInstance((process.env.REACT_APP_API_URL || "") + "/common");

export default axiosInstance;
export { axiosInstanceCommon };
